import React from 'react';
import { useNavigate } from 'react-router-dom';

import { createService, updateService } from 'api/Service';

import { ia, io } from 'lib/helpers/utility';
import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import { showAlert } from 'components/shared/Alert/Alert';

import { getServiceChanges } from '../lib/helpers';

import NewServiceModal from './NewServiceModal/NewServiceModal';
import {
  SERVICE_CREATED_ERROR_MESSAGE,
  SERVICE_CREATED_SUCCESS_MESSAGE,
  SERVICE_QUERY_KEY,
  SERVICE_UPDATED_ERROR_MESSAGE,
  SERVICE_UPDATED_SUCCESS_MESSAGE
} from './NewServiceModal/lib/constants';

const ServiceModal = ({ item: service, isOpen, handleClose }) => {
  const navigate = useNavigate();

  const { mutateAsync: createServiceMutation, isLoading: createServiceLoading } = useCustomMutation(
    {
      mutationFn: (params) => createService(navigate, params),
      invalidateQueryKey: SERVICE_QUERY_KEY,
      successMessage: SERVICE_CREATED_SUCCESS_MESSAGE,
      errorMessage: SERVICE_CREATED_ERROR_MESSAGE,
      onSuccess: () => {
        handleClose();
      }
    }
  );

  const { mutateAsync: updateServiceMutation, isLoading: updateServiceLoading } = useCustomMutation(
    {
      mutationFn: (params) => updateService(navigate, params),
      invalidateQueryKey: SERVICE_QUERY_KEY,
      successMessage: SERVICE_UPDATED_SUCCESS_MESSAGE,
      errorMessage: SERVICE_UPDATED_ERROR_MESSAGE,
      onSuccess: () => {
        handleClose();
      }
    }
  );

  const updateServiceHandler = async (updatedService, payScheduleChanges) => {
    const serviceChanges = getServiceChanges(updatedService, service);

    if (!io(serviceChanges) && !ia(payScheduleChanges)) {
      showAlert({ title: 'Service update', message: 'No changes detected', color: 'warning' });
      return;
    }

    const updatedServiceObj = {
      service_id: service.id,
      ...(io(serviceChanges) && { fields: serviceChanges }),
      ...(ia(payScheduleChanges) && { paySchedule: payScheduleChanges })
    };

    updateServiceMutation(updatedServiceObj);
  };

  const onSave = async (values, paySchedule) => {
    service
      ? await updateServiceHandler(values, paySchedule)
      : await createServiceMutation({ service: values });
  };

  return (
    <NewServiceModal
      service={service}
      isOpen={isOpen}
      isLoading={createServiceLoading || updateServiceLoading}
      onClose={handleClose}
      onSave={onSave}
    />
  );
};

export default ServiceModal;
